import styled from 'styled-components';
import { media } from '../../../../helpers/breakpoints';
import {
  Container as InputContainer,
  InputWithIcon as BaseInputWithIcon,
} from '../../../../components/Toolkit/Inputs/InputWithIcon';
import { Button as BaseButton } from '../../../../components/Toolkit/Button';

export const LookupContainer = styled.div`
  position: relative;
`;

export const LookupWrapper = styled.div`
  margin: 69px 0 0;

  ${media.large} {
    margin: 150px auto 0;
  }
`;

export const TextWrapper = styled.div`
  margin: ${({ theme }) => `${theme.spacing.XL64} auto ${theme.spacing.M24}`};
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${media.large} {
    margin-bottom: ${({ theme }) => theme.spacing.M32};
  }
`;

export const Text = styled.h1`
  ${({ theme }) => theme.fontSize.H24}
  color: ${({ theme }) => theme.colors.WHITE};
  display: flex;
  align-self: flex-end;
  margin: ${({ theme }) => `0 auto ${theme.spacing.M16}`};
  max-width: 290px;
  text-align: center;

  ${media.medium} {
    max-width: 592px;
  }

  ${media.large} {
    ${({ theme }) => theme.fontSize.H32}
  }
`;

export const FormWrapper = styled.div`
  margin: ${({ theme }) => `auto ${theme.spacing.S8}`};

  ${media.large} {
    width: 760px;
    margin: 0 auto;
  }
`;

export const SectionWrapper = styled.div`
  margin: ${({ theme }) => `auto ${theme.spacing.S8}`};
  ${media.large} {
    margin: 0 auto;
    width: 760px;
  }
`;

export const RegistrationLookupContainer = styled.div`
  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  padding: ${({ theme }) => `${theme.spacing.M24} ${theme.spacing.M16}`};
  max-width: 100%;

  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M24};
  }
`;

export const RegistrationLookupContent = styled.div`
  margin: 0 auto;
  width: 100%;

  ${media.large} {
    display: flex;
    width: 592px;
  }
`;

export const Button = styled(BaseButton)`
  ${media.large} {
    align-self: flex-end;
    flex: 1 0 144px;
  }
`;

export const TitleImg = styled.img`
  width: 135px;
  margin: 0 auto;
`;

export const InputWithIcon = styled(BaseInputWithIcon)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};

  ${InputContainer} {
    grid-template-columns: 1fr;
  }

  label {
    ${({ theme }) => theme.fontSize.M16};
    color: ${({ theme }) => theme.colors.GREY};
    margin-bottom: ${({ theme }) => theme.spacing.S8};
  }

  ${media.large} {
    flex: 50%;
    margin-right: ${({ theme }) => theme.spacing.M16};
    margin-bottom: 0;
  }
`;

export const Container = styled.div`
  ${media.large} {
    width: 100%;
    display: flex;
  }
`;
